export default __webpack_public_path__ + "static/media/REI_WHITE.bee2596c.svg";